import React, { useState } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import filterAvailableInventories from "../../../../utils/filterAvailableInventories";
import dayjs from "dayjs";
import "./Calender.css";
function CalendarFilterComponent({
  title,
  selectedDate,
  setSelectedDate,
  providedDate,
  inventories,
  setFilteredInventories,
  isEndDate,
  setSpecialInv,
  clearEndDate,
  width = "120px",
}) {
  const [showOptions, setShowOptions] = useState(false);

  const disabledDate = (current) => {
    const yesterday = moment().subtract(1, "day").endOf("day");
    const provided = providedDate ? moment(providedDate).startOf("day") : null;
    if (isEndDate && provided) {
      return current && (current < yesterday || current <= provided);
    }
    return current && current < yesterday;
  };

  const onChange = (date, dateString) => {
    setSelectedDate(dateString);
    if (clearEndDate && !isEndDate) {
      clearEndDate();
    }
    // if (!dateString || (isEndDate && !providedDate)) {
    //     if(setFilteredInventories){
    //         setFilteredInventories(inventories);
    //         return;
    //     }
    // }
    // if (isEndDate && providedDate) {
    //     let invs = filterAvailableInventories(providedDate, dateString, inventories);
    //     setFilteredInventories(invs);
    // }
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        paddingLeft: "7px",
        borderRadius: "3px",
      }}
      onClick={() => setShowOptions(!showOptions)}
    >
      <div id="FilterMobile" onClick={(e) => e.stopPropagation()}>
        <div style={{ fontWeight: "600" }}>{title}</div>
        <DatePicker
          value={selectedDate ? dayjs(selectedDate, "YYYY-MM-DD") : null}
          onChange={onChange}
          disabledDate={disabledDate}
          style={{ border: "none", width: width }}
          disabled={isEndDate && !providedDate}
        />
      </div>
    </div>
  );
}

export default CalendarFilterComponent;
